var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-alert',{staticClass:"alert-global",attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }